/**
 * Format a monetary amount with currency symbol.
 *
 * Defaults to QAR — the project's standard currency. Callers should only pass
 * a non-default `currency` when the value truly is in another currency
 * (e.g. a payment record carries its own currency field).
 *
 * The name is historical — the helper is currency-agnostic, not USD-specific.
 */
export const dollarFormat = (amount: number, currency: string = 'QAR'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
};
